.icon {
  font-size: 16px;
  width: 1em;
  height: 1em;
  margin-right: .5em;
}
